import {create} from "zustand";

type IsOnlineStore = {
  isOnline: boolean;
  setIsOnline: (isOnline: boolean) => void;
};

export const useIsOnlineStore = create<IsOnlineStore>((set) => ({
  isOnline: true,

  setIsOnline: (isOnline: boolean) => {
    set({
      isOnline,
    });
  },
}));

export function useStoredIsOnline() {
  return useIsOnlineStore((state) => state.isOnline);
}

export function useSetIsOnline() {
  return useIsOnlineStore((state) => state.setIsOnline);
}
